import { useEffect, useState } from "react"
import { Box, Typography, Rating, Avatar } from "@mui/material"
import { useApiService } from "../hooks/Api/useApiService"
import styles from "./SkillsRating.module.css"

const SkillRating = ({ rating, text, skillName, user_name }) => {
  const [user, setUser] = useState(null)
  const { postData } = useApiService()

  useEffect(() => {
    postData("users/getuser", {
      user_name: user_name,
    }).then((data) => {
      setUser(data?.user[0])
    })
  }, [user])

  return (
    <div className={styles.skillsrating_container}>
      <Box className={styles.row_container}>
        <Box className={styles.sr_innerbox}>
          <Avatar alt={user?.user_name} src={user?.image} className={styles.avatar} />
          <Typography variant='h6'>{user?.user_name + "  -"}</Typography>
          <Typography variant='subtitle1' className={styles.skillname}>
            {skillName}
          </Typography>
        </Box>
        <Rating value={rating} precision={1} readOnly className={styles.rating} />
      </Box>
      <Typography variant='body1'>{text}</Typography>
    </div>
  )
}

export default SkillRating
